import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useRef, useState } from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap'
import Streaming from '../../services/_realtime/price/LegacyStreaming';
import { SecurityDetailServiceApi, Configuration as ActionHubConfig } from '../../services/actionHub';
import NumberFormatter from '../../formatters/NumberFormatter';

import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faCircle } from '@fortawesome/pro-solid-svg-icons';
import './index.scss';
import '../../components/dataTables/dataTable.scss';
import Spinner from '../spinner';
import { useNavigate } from 'react-router-dom';
import { APIControl } from '../../helpers/APIControl';
import { set } from 'lodash';
import { useTranslation } from 'react-i18next';

export default function BestWorstHigh(props) {
    const navigate = useNavigate();
    const {i18n} = useTranslation();
    const token = useSelector((state) => state.auth?.token);
    const securityDetailServiceApi = new SecurityDetailServiceApi(new ActionHubConfig({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const streamingRef = useRef(null);
    const unsubscribe = useRef(null);
    const numberFormatterRef = useRef();
    const [isLoadingTable, setIsLoadingTable] = useState(true);
    const [tableData, setTableData] = useState([]);
    const language = i18n.language;

    const [columnsData, setColumnsData] = useState([]);
    const [secMap, setSecMap] = useState({});

    const isValidSymbolCode = (code) => {
        if (!code) {
            return false;
        }
        const trimmed = typeof code === 'string' ? code.trim() : code;
        return trimmed !== '' && trimmed !== '#ERROR';
    };

    const resolveSymbolCode = (data, msg) => {
        if (data && typeof data === 'object' && data.symbolCode) {
            return data.symbolCode;
        }
        if (msg && msg.symbolCode) {
            return msg.symbolCode;
        }
        if (msg && msg.code) {
            return msg.code;
        }
        if (msg && typeof msg.uniqueCode === 'string') {
            return msg.uniqueCode.split(':')[0];
        }
        return undefined;
    };

    useEffect(() => {

        if (columnsData.length == 0) {

            setColumnsData(props.columns);
            console.log(props.title, props.columns);
        }

        if (numberFormatterRef.current == undefined) {
            numberFormatterRef.current = new NumberFormatter();
        }

        if (!streamingRef.current) {
            streamingRef.current = new Streaming();

            let objectIds = props.objectIds;

            unsubscribe.current = streamingRef.current.subscribe({ objectIds: objectIds }, (data) => {
                processPriceMessage(data);
            });
        }

        return () => {
            if (streamingRef.current) {
                unsubscribe.current.Dispose();
            }
        };

    }, []);

    // useEffect(() => {
    //     console.log(props.title, columnsData);
    // }, [columnsData]);

    // useEffect(() => {

    //     if (tableData.length > 0) {

    //         console.log('tableData: ', tableData);

    //     }
    // }, [tableData]);


    useEffect(() => {


        // tableData.forEach((item) => {
        //     if (secMap[item['@']]) {
        //         item.symbolCode = secMap[item['@']].symbolCode;
        //     }
        // }
        // );
        if (!Object.keys(secMap).length) return;
        setTableData((prev) => {
            const updatedRows = prev.map((row) => {
                const detail = secMap[row['@']];
                // symbolCode henüz boşsa veya değiştiyse güncelle
                return detail && detail.symbolCode && row.symbolCode !== detail.symbolCode
                    ? { ...row, symbolCode: detail.symbolCode }
                    : row;
            });
            return updatedRows.filter((row) => isValidSymbolCode(row.symbolCode));
        });

    
    }, [secMap]);



    const processPriceMessage = async (msg) => {
        var cmd = msg['@'];

        if (!cmd || cmd === 'heartbeat' || cmd === 'handshake' || cmd === 'Handshake') {
            return;
        }

        const objectId = msg.objectId ?? msg.id;

        if (objectId) {
            try {
                const data = await populateSecDetail({ objectId: objectId, '@': msg["@"] });  // Asenkron çağrı
                const symbolCode = resolveSymbolCode(data, msg);
                if (symbolCode) {
                    if (data && typeof data === 'object' && data.symbolCode) {
                        setSecMap((prevMap) => {
                            return { ...prevMap, [msg["@"]]: data };
                        });
                    }
                    updateTableData({ ...msg, symbolCode: symbolCode });
                    return;
                    // msg.symbolCode = data;
                    // updateTableData(msg);
                }
            } catch (error) {
                console.error('Error security details:', error);
            }
        }


        const fallbackSymbolCode = resolveSymbolCode(null, msg);
        updateTableData(fallbackSymbolCode ? { ...msg, symbolCode: fallbackSymbolCode } : msg);

    };

    const buildComparator = (sortKey = 'dailyChange', sortOrder = -1) => {
        return (a, b) => {
        const valA = a[sortKey] ?? 0;
        const valB = b[sortKey] ?? 0;

        if (valA === valB) {
            return (a.symbolCode ?? '').localeCompare(b.symbolCode ?? '');
        }
        return sortOrder === -1 ? valB - valA : valA - valB;
        };
    };
    const updateTableData = (msg) => {
        setTableData((prevData) => {
            const existingObjectIndex = prevData.findIndex((obj) => obj['@'] === msg['@']);
            const sortKey   = props.sortField ?? 'dailyChange';  
            const sortOrder = props.sortOrder ?? -1;      
            const comparator = buildComparator(sortKey, sortOrder);
            let newData;
            if (existingObjectIndex !== -1) {
                newData = prevData.map((item) => {
                    if (item['@'] === msg['@']) {
                        // if (msg.dailyChange) {
                        //     if (item.dailyChange == 0) {
                        //         item.dailyChangeColor = 'grey';
                        //     } else if (item.dailyChange > msg.dailyChange) {
                        //         item.dailyChangeColor = 'red';
                        //     } else if (item.dailyChange < msg.dailyChange) {
                        //         item.dailyChangeColor = 'green';
                        //     } else {
                        //         item.dailyChangeColor = 'green';
                        //     }
                        //     item.dailyChange = numberFormatterRef.current.Double(msg.dailyChange, 2);
                        // }
                        if (msg.dailyChange) {
                            // Renk sadece değerin pozitif/negatif olmasına göre belirlenir
                            if (msg.dailyChange == 0) {
                                item.dailyChangeColor = 'grey';
                            } else if (msg.dailyChange > 0) {
                                item.dailyChangeColor = 'green';
                            } else {
                                item.dailyChangeColor = 'red';
                            }
                            item.dailyChange = numberFormatterRef.current.Double(msg.dailyChange, 2);
                        }

                        if (msg.lastPrice) {
                            let formattedValue = numberFormatterRef.current.Double(msg.lastPrice, 2);
                            item.lastPrice = formattedValue;
                        }

                        if (msg.marketCap) {
                            // let formattedValue = numberFormatterRef.current.Double(msg.marketCap / 1000000.0, 0);
                            // let parts = formattedValue.split(",");
                            // if (parts.length > 1) {
                            //     parts[parts.length - 1] = parts[parts.length - 1].slice(0, 2);
                            // }
                            // let result = parts.join(",");
                            // msg.marketCapFormat = result;
                            item.marketCap = msg.marketCap;
                            const valueInMln = msg.marketCap / 1_000_000;
                            item.marketCapFormat = numberFormatterRef.current
                                .formatNumberDecimal(valueInMln, 0); 
                        }

                        if (msg.dailyValue) {
                            let formattedValue = numberFormatterRef.current.Double(msg.dailyValue / 1000000.0, 2);
                            item.dailyValueFormat = formattedValue;
                        }
                    }
                    return item;
                });

                setTimeout(() => {
                    setIsLoadingTable(false);
                }, 1000);

                // const sortedData = newData.sort((a, b) => {

                //     if (a.dailyChange === b.dailyChange) {
                //         if (a.symbolCode && b.symbolCode) {
                //             return a.symbolCode.localeCompare(b.symbolCode);
                //         }
                //         return 1; // Eğer symbolCode tanımlı değilse eşit kabul et
                //     }
                //     return b.dailyChange - a.dailyChange;
                // });

                // return sortedData;
                const filteredData = newData.filter((row) => isValidSymbolCode(row.symbolCode));
                return filteredData.sort(comparator);
            } else {
                if (!isValidSymbolCode(msg.symbolCode)) {
                    return prevData.filter((row) => row['@'] !== msg['@']);
                }
                if (msg.dailyChange) {
                    if (msg.dailyChange > 0) {
                        msg.dailyChangeColor = 'green';
                    } else if (msg.dailyChange < 0) {
                        msg.dailyChangeColor = 'red';
                    } else {
                        msg.dailyChangeColor = 'grey';
                    }
                    msg.dailyChange = numberFormatterRef.current.Double(msg.dailyChange, 2);
                }

                if (msg.lastPrice) {
                    let formattedValue = numberFormatterRef.current.Double(msg.lastPrice, 2);
                    msg.lastPrice = formattedValue;
                }

                if (msg.marketCap) {
                    let formattedValue = numberFormatterRef.current.Double(msg.marketCap / 1000000.0, 0);
                    // let parts = formattedValue.split(",");
                    // if (parts.length > 1) {
                    //     parts[parts.length - 1] = parts[parts.length - 1].slice(0, 2);
                    // }
                    // let result = parts.join(",");
                    msg.marketCapFormat = formattedValue;
                }

                if (msg.dailyValue) {
                    let formattedValue = numberFormatterRef.current.Double(msg.dailyValue / 1000000.0, 2);
                    msg.dailyValueFormat = formattedValue;
                }

                const newItem = {
                    '@': msg['@'],
                    symbolCode: msg.symbolCode,
                    marketCap: msg.marketCap,
                    lastPrice: msg.lastPrice,
                    dailyChangeColor: msg.dailyChangeColor,
                    dailyChange: msg.dailyChange,
                    dailyValue: msg.dailyValue,
                    marketCapFormat: numberFormatterRef.current.formatNumberDecimal((msg.marketCap ?? 0) / 1_000_000, 0),
                    dailyValueFormat: msg.dailyValueFormat
                };

                setTimeout(() => {
                    setIsLoadingTable(false);
                }, 1000);
                const updatedRows = [...prevData, newItem];
                const filtered = updatedRows.filter((row) => isValidSymbolCode(row.symbolCode));
                return filtered.sort(comparator);
                // const sortedData = [...prevData, newItem].sort((a, b) => {
                //     if (a.dailyChange === b.dailyChange) {
                //         if (a.symbolCode && b.symbolCode) {
                //             return a.symbolCode.localeCompare(b.symbolCode);
                //         }
                //         return 0; // Eğer symbolCode tanımlı değilse eşit kabul et
                //     }
                //     return b.dailyChange - a.dailyChange;
                // });

                // return sortedData;
            }
        });
    };


    const populateSecDetail = (args, type) => {
        return new Promise((resolve, reject) => {
            if (!args.objectId) {
                reject("ObjectId is required");
                return;
            }
            const culture = language ;
            securityDetailServiceApi.actionhubSecuritydetailGet(token, args.objectId, culture).then((res) => {
                if (!res.data.detail || res.data.detail.length == 0) {
                    resolve("#ERROR");
                }

                let symbolCode = res.data.detail[0].code;
                resolve({ symbolCode: symbolCode, '@': args['@'] });

            }).catch((err) => {
                console.log(err);
                reject(err);
            });
        });
    };


    const dailyChangeBodyTemplate = (data) => {

        let arrow = 'dot';

        const streamId = data['@'] ?? '';
        const isDailyChange = streamId.includes('dailyChange');
        const isBest = streamId.includes('.best.');
        const isWorst = streamId.includes('.worst.');

        if (isDailyChange && isBest) {
            arrow = 'up';
        }
        else if (isDailyChange && isWorst) {
            arrow = 'down';
        }
        else if (data.dailyChangeColor == 'green') {
            arrow = 'up';
        }
        else if (data.dailyChangeColor == 'red') {
            arrow = 'down';
        }

        return (

            <div className='changeBodyTemplate'>

                <Container >
                    <Row className='changeBodyTemplate'>
                        <Col md='4' sm='4' className=''>
                            {
                                arrow == 'up' ? <FontAwesomeIcon icon={faArrowUp} />
                                    : arrow == 'down' ? < FontAwesomeIcon icon={faArrowDown} />
                                        : <FontAwesomeIcon className='realTimeCircleIcon' icon={faCircle} />
                            }
                        </Col>
                        <Col md='8' sm='8' className='p-0'>

                            {data.dailyChange == 0 &&
                                <label className=''>
                                    {data.dailyChange}

                                </label>
                            }

                            {data.dailyChange !== 0 &&
                                <label className=''>
                                    % {data.dailyChange}
                                </label>
                            }
                        </Col>
                    </Row>
                </Container>

            </div>
        )
    };


    const cellDailyChange = (data) => {

        const streamId = data['@'] ?? '';
        const isDailyChange = streamId.includes('dailyChange');
        const isBest = streamId.includes('.best.');
        const isWorst = streamId.includes('.worst.');

        if (isDailyChange && isBest) {
            return 'realTimeGreenBg';
        }
        else if (isDailyChange && isWorst) {
            return 'realTimeRedBg';
        }

        else if (data.dailyChangeColor == 'green') {
            return 'realTimeGreenBg';
        }
        else if (data.dailyChangeColor == 'red') {
            return 'realTimeRedBg';
        }
        else if (data.dailyChangeColor == 'grey') {
            return 'realTimeGreyBg';
        }
    }


    const codeBodyTemplate = (data, col) => {
        // console.log('codeBodyTemplate col: ', col);
        if (data.symbolCode != undefined || data.symbolCode != null || data.symbolCode != '' || data.symbolCode != '#ERROR') {
            return (
                <div className='roboto-medium-14 tickerCode' onClick={(event) => { navigate(`/StockAnalysis/summary/${data.code || data.symbolCode}`) }}>{data.symbolCode} </div>
            )
        } else {
            return (
                <div className='roboto-medium-14' >{data.symbolCode} </div>
            )
        }
    };

    const marketCapBodyTemplate = (data) => {

        return (
            <div className='roboto-medium-14'>
                {data.marketCapFormat}
            </div>
        )
    }

    const dailyValueBodyTemplate = (data) => {
        return (
            <div className='roboto-medium-14'>
                {data.dailyValueFormat}
            </div>
        )
    }

    return (
        <Card className='most-info-card transition best-worst-high-card'>
            <div className='most-info-card-header'>
                <div className='most-info-card-header-title roboto-bold-16'>
                    {props.title}
                </div>
                <div className='most-info-card-header-icon'>
                    {/* <FontAwesomeIcon className='table-chart-icon' icon={faPencil} /> */}
                </div>
            </div>
            <div className='most-info-card-content'>
                {isLoadingTable && <Spinner height="200px" />}
                {!isLoadingTable && (
                    <DataTable id={'hoveredDataTable'}
                        value={tableData} tableStyle={{}} sortField={props.sortField ? props.sortField : ""}
                        sortOrder={props.sortOrder ? props.sortOrder : 1}
                        >
                        {props.columns
                            && props.columns.map((column, index) => (
                                <Column
                                    key={column.binding}
                                    field={column.binding}
                                    header={column.header}
                                    align={column.align}
                                    className='roboto-medium-14 '
                                    style={{
                                        width: column.width,minWidth: column.minWidth ?? 'auto',paddingLeft: column.binding == 'marketCap' ? '0px' : '10px', textAlign: column.align, padding: "10px"
                                    }}
                                    body={
                                        (column.binding == 'dailyChange' && dailyChangeBodyTemplate)
                                        || (column.binding == 'symbolCode' && codeBodyTemplate
                                            || (column.binding == 'marketCap' && marketCapBodyTemplate)
                                            || (column.binding == 'dailyValue' && dailyValueBodyTemplate)
                                        )
                                    }
                                    bodyClassName={column.binding == 'dailyChange' && cellDailyChange}

                                ></Column>
                            ))}
                    </DataTable>
                )}
            </div>

        </Card>
    )
}
